import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { api } from "@/api/client";

/** The capability catalogue (`app/api/capabilities.py`). */
export type CapabilityKind = "feature" | "setting" | "limitation" | "howto";
export type RoadmapStatus = "noted" | "planned" | "shipped" | "declined";

export type CapabilityCard = {
  id: string;
  kind: CapabilityKind;
  title: string;
  summary: string;
  how: string[];
  link: string | null;
  roadmap: { fw: number; status?: RoadmapStatus; title?: string } | null;
  lang: string;
  score?: number;
};

export type CapabilitySearch = { index_ok: boolean; results: CapabilityCard[] };

export function useCapabilitySearch(q: string, page: string, lang: string, enabled: boolean) {
  return useQuery({
    queryKey: ["capabilities", "search", q, page, lang],
    queryFn: async () =>
      (await api.get<CapabilitySearch>("/capabilities/search", { params: { q, page, lang } })).data,
    enabled: enabled && q.length >= 2,
    staleTime: 60_000,
    placeholderData: keepPreviousData,
    retry: false,
  });
}
